<script setup>
const props = defineProps({
  radius: { type: String, default: 'big' }
})
const emit = defineEmits(['update:radius'])

</script>

<template>
  <div class="button-block theme-corner-radius">
    <button
      v-for="n in ['none', 'small', 'big']"
      :key="n"
      :class="[n, {active: props.radius === n}]"
      @click="emit('update:radius', n)">
      <span :class="[n]" />
    </button>
  </div>
</template>

<style lang='scss' scoped>
.theme-corner-radius {
  display: flex;
  gap: var(--padding-base);
  justify-content: center;

  & > button {
    position: relative;
    // width: var(--size-two-third);
    // height: var(--size-two-third);
    // min-width: unset;
    padding: 0;

    & > * {
      display: block;
      width: 55%;
      height: 55%;
      border: solid #747474;
      border-width: 2px 0 0 2px;

      &.small {
        border-top-left-radius: 8px;
      }
      &.big {
        border-top-left-radius: calc(var(--size-two-third) * var(--border-radius-fact));
      }
    }
    &.active > * {
      border-color: var(--color-text-working);
    }
  }
}
</style>
